/**
 * PAW RECORDS MOCK DATA
 *
 * Centralized mock data for PAW (Performed Audit Websites) records.
 * Uses mockDataManager for localStorage persistence.
 *
 * Part of PE-747: CyberSweep Data Persistence
 */

import { createPersistedMockData } from '../mockDataManager';
import type { PAWRecord } from '../../types';

/**
 * DEFAULT PAW RECORDS
 * Sample PAW records for CyberSweep audits
 */
export const defaultPAWRecords: PAWRecord[] = [
  {
    id: 'PAW-001001',
    csAuditId: 'CyberAudit-1001',
    clientId: 'client_001',
    clientName: 'John Smith',
    auditTemplate: 'Q3 2025',
    website: '411 Whitepages',
    phase2Required: true,
    createdBy: 'Admin User',
    auditPhase: 'Phase 1',
    findings: 'Personal information found including phone number and address',
    method: 'Manual Search',
    piiFound: true,
    clientInfoLinks: [
      'https://www.whitepages.com/name/john-smith'
    ],
    lastModifiedBy: 'Sarah Johnson',
    lastModifiedDate: '2025-09-20T14:30:00Z',
    createdDate: '2025-09-15T10:00:00Z',
    status: 'Completed'
  },
  {
    id: 'PAW-001002',
    csAuditId: 'CyberAudit-1001',
    clientId: 'client_001',
    clientName: 'John Smith',
    auditTemplate: 'Q3 2025',
    website: 'Been Verified',
    phase2Required: false,
    createdBy: 'Admin User',
    auditPhase: 'Phase 1',
    findings: 'No current listing found',
    method: 'Automated Scan',
    piiFound: false,
    clientInfoLinks: [],
    lastModifiedBy: 'Sarah Johnson',
    lastModifiedDate: '2025-09-18T09:15:00Z',
    createdDate: '2025-09-16T11:30:00Z',
    status: 'Completed'
  },
  {
    id: 'PAW-001003',
    csAuditId: 'CyberAudit-1001',
    clientId: 'client_001',
    clientName: 'John Smith',
    auditTemplate: 'Q3 2025',
    website: 'Instantcheckmate',
    phase2Required: true,
    createdBy: 'Admin User',
    auditPhase: 'Phase 1',
    findings: 'Profile found with relatives and previous addresses',
    method: 'Manual Search + Automated',
    piiFound: true,
    clientInfoLinks: [
      'https://www.instantcheckmate.com/people/john-smith'
    ],
    lastModifiedBy: 'Sarah Johnson',
    lastModifiedDate: '2025-09-22T16:45:00Z',
    createdDate: '2025-09-17T13:20:00Z',
    status: 'In Progress'
  },
  {
    id: 'PAW-001237',
    csAuditId: 'CyberAudit-1010',
    clientId: 'client_002',
    clientName: 'Amanda Johnson',
    auditTemplate: 'Coming soon',
    website: 'www.mylife.com',
    phase2Required: true,
    createdBy: 'Admin User',
    auditPhase: 'Initial Review',
    findings: 'Profile page with contact information',
    method: 'Manual Search',
    piiFound: true,
    clientInfoLinks: [
      'https://www.mylife.com/amanda-johnson'
    ],
    lastModifiedBy: 'Admin User',
    lastModifiedDate: '2025-09-19T11:20:00Z',
    createdDate: '2025-09-15T14:00:00Z',
    status: 'Completed'
  }
];

/**
 * PERSISTED STORAGE
 * Data persists in localStorage under key 'crm_paw_records'
 */
export const persistedPAWRecords = createPersistedMockData<PAWRecord>(
  'crm_paw_records',
  defaultPAWRecords
);

/**
 * BACKWARD COMPATIBILITY
 */
export const mockPAWRecords = defaultPAWRecords;
